import SuccessPic from '@/ui/assets/success-icon.svg';
import { Button, Heading, Text, Translation } from '@/ui/components';
import cn from 'classnames';
import Image from 'next/image';

import s from './SuccessRegister.module.css';

const SuccessRegister = () => {
  return (
    <article className={cn(s.wrapper)}>
      <Image src={SuccessPic} className={s.picture} alt="Success Image" />

      <Heading spacing="tiny" centerText weight="medium">
        <Translation context="success_register" token="title" />
      </Heading>
      <Text centerText spacing="semi">
        <Translation context="success_register" token="description" />
      </Text>
      <Button isFullWidth href={`/account/login`}>
        <Translation context="success_register" token="button" />
      </Button>
    </article>
  );
};

export default SuccessRegister;
